import { render } from "./gallery.vue?vue&type=template&id=7e600b79&ts=true"
import script from "./gallery.vue?vue&type=script&lang=ts"
export * from "./gallery.vue?vue&type=script&lang=ts"

import "./gallery.vue?vue&type=style&index=0&id=7e600b79&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__